/**
 * Canonical redirects for calculator pages that are intentionally generated
 * without a second interactive calculator entry.
 *
 * Keep the source slug and destination together here. Both the prerenderer and
 * its release guard import this exact list so adding a redirect cannot silently
 * update only one side of the release contract.
 */
export const CALCULATOR_REDIRECTS = Object.freeze([
  Object.freeze({
    sourceSlug: 'health-ovulation-date-calculator',
    canonicalPath: '/calculator/ovulation-calculator/',
    title: 'Ovulation Date Calculator',
    linkText: 'Ovulation &amp; Fertile Window Calculator',
  }),
  Object.freeze({
    sourceSlug: 'construction-concrete-volume-calculator',
    canonicalPath: '/calculator/concrete-volume-calculator/',
    title: 'Concrete Volume Calculator',
    linkText: 'Concrete Volume Calculator',
  }),
  Object.freeze({
    sourceSlug: 'health-drug-interaction-calculator',
    canonicalPath: '/calculator/health-medication-timing-calculator/',
    title: 'Drug Interaction Calculator',
    linkText: 'Medication Timing Calculator',
  }),
  Object.freeze({
    sourceSlug: 'health-anxiety-level-calculator',
    canonicalPath: '/calculator/health-stress-score-calculator/',
    title: 'Stress Score Calculator',
    linkText: 'Stress Score Calculator',
  }),
  Object.freeze({
    sourceSlug: 'health-depression-screen-calculator',
    canonicalPath: '/calculator/health-stress-score-calculator/',
    title: 'Stress Score Calculator',
    linkText: 'Stress Score Calculator',
  }),
]);

export function getCalculatorRedirect(sourceSlug) {
  return CALCULATOR_REDIRECTS.find(redirect => redirect.sourceSlug === sourceSlug);
}

export function renderCalculatorRedirectHtml(redirect) {
  return `<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8"/><title>${redirect.title} | UnitedCalculator</title><link rel="canonical" href="https://unitedcalculator.com${redirect.canonicalPath}"/><meta http-equiv="refresh" content="0;url=${redirect.canonicalPath}"/><script>window.location.replace('${redirect.canonicalPath}');</script></head><body><p>Redirecting to <a href="${redirect.canonicalPath}">${redirect.linkText}</a>…</p></body></html>`;
}